import React, { Component } from 'react';
import config from '../config';
import Canvas from './Canvas';
import * as createjs from 'createjs-module';
import Rectangle from '../graphics/Rectangle';
import TaskList from '../graphics/TaskList';
import Task from '../graphics/Task';
import { connect } from 'react-redux';
import {
  addItem, updateItems, addCanvas, addStage, addDisplayObject, wait, addHandler, startTween,
  sendActionId, setActionMap, actions
} from '../actions';
import {createStage, changeShapeColor} from '../graphics/cjs-lib';
import { Tree } from '../graphics/Tree';
import { ActionMap } from '../graphics/ActionMap';
import { test1 } from '../graphics/AnimationActions';
// import Heap, { heapAnimation } from './Heap';
import HeapController from './Heap';
import ProjectDescription from './ProjectDescription';

window.createjs = createjs;


export class Animation extends Component {
  constructor(props) {
    super(props);
    // this.state = { angle: 0 };
    this.updateAnimationState = this.updateAnimationState.bind(this);
    this.angle = 0;
    /**
     * @type {Array<TaskList>}
     */
    this.taskQueue = [];
    /**
     * @type TaskList
     * @type {null}
     */
    this.currentTaskList = null;
    this.previousTimeStamp = null;
    this.stage = null;
    this._canvas = null;
    this._pureCanvas = null;
    this.canvas = null;
    this.actionId = 1;
    this.animationActions = null;
    this.nextId = 1;
    this.nextActionId = 1;
  }

  static setNextId(nextId) {
    Animation.nextId = nextId;
  }

  static getNextId() {
    return Animation.nextId++;
  }

  static setNextActionId(nextActionId) {
    Animation.nextActionId = nextActionId;
  }

  static getNextActionId() {
    return Animation.nextActionId++;
  }

  static setNextTweenId(nextTweenId) {
    Animation.nextTweenId = nextTweenId;
  }

  static getNextTweenId() {
    return Animation.nextTweenId++;
  }

  addTaskList(taskList) {
    this.taskQueue.push(taskList);
  }

  setup() {
    if (config.useNativeCanvas) {
      this.setupNativeCanvas();
    } else {
      if (this._pureCanvas) {
        this.canvas = this._pureCanvas._canvas;
        console.log(this.canvas);
        this.setupCreatejs();
      }
    }
  }

  async setupCreatejs() {
    const dispatch = this.props.dispatch;
    dispatch(addCanvas({ canvas: this.canvas, actionId: 1 }));
    this.stage = createStage(this.canvas);
    dispatch(addStage({ stage: this.stage, actionId: 1 }));
    const actionMap = new ActionMap();
    // this.animationActions = new AnimationActions({ actionMap, animation: this });
    const useHeap = true;
    if (useHeap) {
      // heapAnimation({ actionMap, n: 15 });
    } else {
      test1({ actionMap });
    }
    dispatch(setActionMap({ actionMap }));
  }

  componentDidUpdate(prevProps) {
    let useMap = true;
    let nextTask;
    /**
     * @type ActionMap
     */
    const dispatch = this.props.dispatch;
    if (useMap) {
      /**
       * @type ActionMap
       */
      const { actionMap } = this.props;
      const previousActionMap = prevProps.actionMap;
      /**
       * If actionMap has just updated, do not get the nextTask, since that is waiting
       * to be executed
       */
      if ( previousActionMap && previousActionMap === actionMap) {
        return;
      }
      if (!actionMap) {
        return;
      }
      nextTask = Animation.getNext({ actionMap });
      if ( actionMap && nextTask ) {
        const actionId = nextTask.actionId;
        const newActionMap = actionMap.clone();
        newActionMap.updateStartedStatus({ actionId, status: true });
        dispatch(setActionMap({ actionMap: newActionMap }));
        dispatch(nextTask.f(nextTask.parameters));
      }
    } else if (this.props.actionIds) {
      const actionIds = this.props.actionIds;

      let bounds;
      let attrs;
      let value;
      let tweenCommand;
      let tweenItem;
      let cb;
      let callback;
      let handler;
      let actionId = this.actionId;
      let previousActionId;
      let incrementActionId = () => {
        this.actionId += 1;
        actionId = this.actionId;
        previousActionId = actionId - 1;
      };
      console.log('componentDidUpdate actionIds', actionIds.toString());
      console.log((new Date()).toLocaleTimeString());

      if (actionIdCondition({actionIds, excludesList: [2], includesList: [1]})) {
        incrementActionId();
        bounds = {x: 0, y: 0, width: 200, height: 200};
        attrs = {x: 200, y: 200, color: '#f00', alpha: 1};
        value = {bounds, attrs, name: 'center'};
        dispatch(addDisplayObject({
          parentId: 0,
          id: 1,
          type: 'SHAPE_MOVIE_CLIP',
          value,
          actionId
        }));
      }
      if (actionIdCondition({actionIds, excludesList: [3], includesList: [2]})) {
        incrementActionId();
        dispatch(wait({
          delay: 2000,
          actionId
        }));
      }
      if (actionIdCondition({actionIds, excludesList: [4], includesList: [3]})) {
        incrementActionId();
        bounds = { x: 0, y: 0, width: 100, height: 100};
        attrs = { x: 50, y: 50, color: '#0f0', alpha: 1};
        value = { bounds, attrs, score: 1 };
        dispatch(addDisplayObject({
          parentId: 0,
          id: 2,
          type: 'SHAPE_MOVIE_CLIP',
          value,
          actionId
        }));
      }
      if (actionIdCondition({actionIds, excludesList: [5], includesList: [4]})) {
        incrementActionId();
        bounds = { x: 0, y: 0, width: 100, height: 100};
        attrs = { x: 50, y: 450, color: '#0ff', alpha: 1};
        value = { bounds, attrs, score: 1 };
        dispatch(addDisplayObject({
          parentId: 0,
          id: 3,
          type: 'SHAPE_MOVIE_CLIP',
          value,
          actionId
        }));
      }
      if (actionIdCondition({actionIds, excludesList: [6], includesList: [5]})) {
        incrementActionId();
        cb = () => {
          const color1 = '#ff0';
          const color2 = '#00f';
          let color = color1;
          return function (evt) {
            const shape = evt.target.children[0];
            color = color === color1 ? color2 : color1;
            changeShapeColor({ shape, color });
            this.value.score = typeof this.value.score === 'number' ? this.value.score : 0;
            this.value.score += 1;
            console.log('handler', this.value);
          };
        };
        callback = cb();
        handler = new Handler({ action: 'click', callback, id: 1 });
        dispatch(addHandler({ id: 1, actionId, handler }));
      }
      if (actionIdCondition({actionIds, excludesList: [7], includesList: [6]})) {
        incrementActionId();
        incrementActionId();
        tweenCommand = new TweenCommand({
          type: 'to',
          value: { x: 400 },
          dt: 3000
        });
        tweenItem = new TweenItem({ tweenId: 1, id: 2, commands: [tweenCommand], actionId });
        dispatch(startTween({ tweenItem, actionId, startActionId: previousActionId }));
      }
      if (actionIdCondition({actionIds, excludesList: [8, 9], includesList: [7]})) {
        incrementActionId();
        incrementActionId();
        tweenCommand = new TweenCommand({
          type: 'to',
          value: { x: 400 },
          dt: 2000
        });
        tweenItem = new TweenItem({ tweenId: 2, id: 3, commands: [tweenCommand], actionId });
        dispatch(startTween({ tweenItem, actionId, startActionId: previousActionId }));
      }
      if (actionIdCondition({actionIds, excludesList: [12], includesList: [8]})) {
        dispatch(sendActionId({actionId: 12}));
        incrementActionId();
        incrementActionId();
        tweenCommand = new TweenCommand({
          type: 'to',
          value: { y: 400 },
          dt: 3000
        });
        tweenItem = new TweenItem({ tweenId: 1, id: 2, commands: [tweenCommand], actionId });
        dispatch(startTween({ tweenItem, actionId, startActionId: previousActionId }));
      }
    }
  }

  setupNativeCanvas() {
    const rectangle = new Rectangle({id: 1, cx: 300, cy: 300, width: 100, height: 100, angle: 0, fill: '#00f' });
    this.props.dispatch(addItem(rectangle));

    let taskList;
    let task;
    let dt = 3000;
    taskList = new TaskList({ dt });
    task = new Task({ item: rectangle, attributes: { angle: 360}});
    taskList.addTask(task);
    this.addTaskList(taskList);

    taskList = new TaskList({ dt });
    task = new Task({ item: rectangle, attributes: { cx: 100, cy: 100, width: 200, height: 200 }});
    taskList.addTask(task);
    this.addTaskList(taskList);

    taskList.getPromise()
      .then(() => {
        console.log('TaskList 2 finished');
      });

    taskList = new TaskList({ dt });
    task = new Task({ item: rectangle, attributes: { cx: 500}});
    taskList.addTask(task);
    this.addTaskList(taskList);

    taskList = new TaskList({ dt });
    task = new Task({ item: rectangle, attributes: { cy: 500}});
    taskList.addTask(task);
    this.addTaskList(taskList);

    taskList = new TaskList({ dt });
    task = new Task({ item: rectangle, attributes: { cx: 100}});
    taskList.addTask(task);
    this.addTaskList(taskList);

    taskList = new TaskList({ dt });
    task = new Task({ item: rectangle, attributes: { cy: 100}});
    taskList.addTask(task);
    this.addTaskList(taskList);

    taskList = new TaskList({ dt });
    task = new Task({ item: rectangle, attributes: { cy: 100}});
    taskList.addTask(task);

    taskList = new TaskList({ dt });
    task = new Task({ item: rectangle, attributes: { cx: 300, cy: 300, width: 100, height: 100}});
    taskList.addTask(task);
    this.addTaskList(taskList);

    taskList = new TaskList({ dt });
    task = new Task({ item: rectangle, attributes: { angle: 0}});
    taskList.addTask(task);
    this.addTaskList(taskList);
  }

  componentDidMount() {
    if (this._canvas) {
      this._pureCanvas = this._canvas._pureCanvas;
    }
    this.setup();
    this.previousTimeStamp = Date.now();
    if (this.useNativeCanvas) {
      this.rAF = requestAnimationFrame(this.updateAnimationState);
    }
  }

  updateAnimationState() {
    const timeStamp = Date.now();
    if (!this.currentTaskList && !this.taskQueue.length) {
      return;
    }
    if (!this.currentTaskList) {
      this.currentTaskList = this.taskQueue.shift();
      this.currentTaskList.setStartTimestamp(this.previousTimeStamp);
    }
    const { items, done } = this.currentTaskList.updateItems(this.props.items);
    if (done) {
      this.currentTaskList = null;
    }
    this.props.dispatch(updateItems(items));
    this.previousTimeStamp = timeStamp;
    this.rAF = requestAnimationFrame(this.updateAnimationState);
  }

  componentWillUnmount() {
    cancelAnimationFrame(this.rAF);
  }

  render() {
    const { width, height, angle, items } = this.props;
    // return <Canvas width={width} height={height} angle={angle} items={items} ref={c => this._canvas = c}/>;
    return (<div>
      <Canvas width={width} height={height} angle={angle} items={items} ref={c => this._canvas = c}/>
      <HeapController />
      <ProjectDescription/>
    </div>);
  }

  static getNext({ actionMap }) {
    /**
     * @type ActionItem actionItem
     */
    for (let actionItem of actionMap.values()) {
      if (!actionItem.actionTask) {
        continue;
      }
      if (actionItem.actionTask.started) {
        continue;
      }
      let ready = true;
      let parentActionItem;
      let pc;
      const parentConditions = actionItem.parentConditions;
      for (let i = 0; i < parentConditions.length; i++) {
        pc = parentConditions[i];
        if (actionMap.has(pc.actionId)) {
          parentActionItem = actionMap.get(pc.actionId);
          if (!parentActionItem.actionTask[pc.status]) {
            ready = false;
          }
        }
      }
      if (ready) {
        console.log('executing actionItem', actionItem);
        /**
         * @type ActionTask
         */
        const actionTask = actionItem.actionTask;
        const actionId = actionItem.actionId;
        const actionType = actionTask.actionType;
        const parameters = actionTask.parameters;
        const f = actions[actionType];
        return { actionId, f, parameters };
      }
    }
    console.log('Animation.getNext: no more ready tasks');
    return false;
  }
}
Animation.nextId = 1;
Animation.nextActionId = 1;
Animation.nextTweenId = 1;

export class TweenCommand {
  constructor({type, value, dt}) {
    if (!['wait', 'set', 'call', 'to'].includes(type)) {
      throw new Error(`invalid tweenCommand.type ${type}`);
    }
    this.dt = 0;
    this.value = {};
    switch (type) {
      case 'set':
      case 'to':
        if (!(value instanceof Object)) {
          throw new Error(`${type} must have value be an object`);
        }
        this.value = value;
        break;
      case 'call':
        if (typeof value !== 'function') {
          throw new Error(`${type} must have value be a function`);
        }
        this.value = value;
        break;
      case 'wait':
        if (typeof dt !== 'number') {
          throw new Error(`${type} must have dt be a number`);
        }
        break;
      default:
    }
    this.type = type;
    if (typeof dt === 'number') {
      this.dt = dt;
    }
  }
}

export class TweenItem{
  constructor({ tweenId, id, commands }) {
    this.tweenId = tweenId;
    this.id = id;
    this.commands = commands;
    this.start = null;
  }
}

export function createTween({tree, id, commands}) {
  if (!tree || !(tree instanceof Tree)) {
    throw new Error('createTween must be passed a tree');
  }
  if (!tree.contains(id)) {
    return false;
  }
  if (!Array.isArray(commands)) {
    throw new Error('createTween must be passed an array of commands');
  }
  commands.forEach(command => {
    if (!(command instanceof TweenCommand)) {
      throw new Error('createTween must be passed an array of commands');
    }
  });
  const node = tree.get(id);
  if (!node.displayObject) {
    console.error(`createTween has no DisplayObject for id ${id}`);
    return;
  }
  let tween = createjs.Tween.get(node.displayObject, { override: true });
  commands.forEach(command => {
    switch (command.type) {
      case 'wait':
        tween = tween.wait(command.dt);
        break;
      case 'to':
        tween = tween.to(command.value, command.dt);
        break;
      case 'set':
        tween = tween.set(command.value);
        break;
      case 'call':
        tween = tween.call(command.value);
        break;
      default:
    }
  });
  return tween;
}

export function createTweenAndPromise({ tree, id, commands }) {
  let tween;
  const promise = new Promise((resolve, reject) => {
    try {
      const callResolve = new TweenCommand({ type: 'call', value: resolve });
      commands.push(callResolve);
      tween = createTween({ tree, id, commands });
    } catch (ex) {
      reject(ex);
    }
  });
  return { tween, promise };
}

export let events = ['click', 'mouseover', 'mouseout'];

export class Handler {
  constructor({ action, callback, id }) {
    if (!events.includes(action)) {
      throw new Error(`Handler has invalid action ${action}`);
    }
    if (typeof callback !== 'function') {
      throw new Error('Handler must be passed a callback function');
    }
    this.action = action;
    this.callback = callback;
    this.id = id;
  }
}

/*
function wait(delay) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, delay);
  });
}
*/

function actionIdCondition({ actionIds, includesList = [], excludesList = [] }) {
  for (let i = 0; i < includesList.length; i++) {
    const id = includesList[i];
    if (!actionIds.includes(id)) {
      return false;
    }
  }
  for (let i = 0; i < excludesList.length; i++) {
    const id = excludesList[i];
    if (actionIds.includes(id)) {
      return false;
    }
  }
  return true;
}

function mapStateToProps(state) {
  return { ...state };
}

export default connect(mapStateToProps)(Animation);
